import { render, staticRenderFns } from "./config_gotify_server.vue?vue&type=template&id=6488d3a4"
import script from "./config_gotify_server.vue?vue&type=script&lang=js"
export * from "./config_gotify_server.vue?vue&type=script&lang=js"
import style0 from "./config_gotify_server.vue?vue&type=style&index=0&id=6488d3a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports